<template>
  <div class="page" id="loginPage">
    <div class="login-logo"></div>
    <div class="login-wrap">
      <el-form :model="ruleForm" ref="ruleForm" class="login-container">
        <div class="fl title">Log into Linkplus</div>
        <div class="subtitle" style="margin-top: 50px">
          <div class="userName ft-16">User Account</div>
          <!-- <a class="newAccount"
            href="mailto:linkplus@vivachek.com?subject=New%20Account%20Creation&body=I'd%20like%20to%20create%20a%20new%20account.%0D%0AMy%20email%20address%20as%20my%20username%3A%20%5B%20%5D%0D%0AMy%20Glucose%20Meters%20Number%20%3A%20%5B%20%5D%0D%0ASeparate%20multiple%20devices%20with%20commas%20(,)">
            <img style="margin-right: 10px;" src="../assets/images/icon-prompt.svg">Get a new
            account</a> -->
          <div class="newAccount ft-16" @click="handleCreateAccount">
            <img style="margin-right: 10px;" src="../assets/images/icon-prompt.svg">Get a new
            account
          </div>
        </div>
        <el-form-item prop="username" style="margin-top: 10px">
          <el-input class="login-input" type="text" v-model="ruleForm.username" auto-complete="off"
            placeholder="Enter your e-mail">
            <!-- <template v-slot:prefix>
              <img class="user-icon" src="../assets/images/icon-user.svg">
            </template> -->
          </el-input>
        </el-form-item>

        <div class="subtitle">
          <div class="password ft-16">Password</div>
          <div class="password-reset ft-16" style="margin-right:18px" @click="handleRestPassword"> <img
              style="margin-right: 10px;" src="../assets/images/icon-prompt.svg"> Reset
            password</div>
        </div>
        <el-form-item prop="password" style="margin-top: 10px">
          <el-input class="login-input" :type="showPassword ? 'password' : 'text'" v-model="ruleForm.password"
            auto-complete="off" placeholder="Enter the password">
            <!-- <template v-slot:prefix>
              <img class="lock-icon" src="../assets/images/icon-lock.svg">
            </template> -->
            <template v-slot:suffix>
              <img class="secrecy-icon" @click="handlePasswordVisibility" :src="eyeIcon">
            </template>
          </el-input>
        </el-form-item>
        <el-form-item style="width: 100%; margin-top: 20px">
          <el-button type="primary" class="login-button ft-16" @click="submitForm()">Log in</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
 
<script>
import { post } from "@/script/api.js";
import { JSEncrypt } from 'jsencrypt'

export default {
  components: {},
  props: {
    // isAdminLogin:Boolean,
  },
  data() {
    return {
      showPassword: true,
      eyeIcon: require('../assets/images/icon-unsecured.png'),
      ruleForm: {
        username: "",
        password: "",
      },

    };
  },
  mounted() {

  },

  methods: {


    submitForm() {
      if (!this.ruleForm.username) {
        this.$message.error("Please enter your user account");
        return false;
      }
      if (!this.ruleForm.password) {
        this.$message.error("Please enter the password");
        return false;
      }
      // 创建 RSA 加密实例
      var encrypt = new JSEncrypt();
      // 设置 RSA 公钥
      var publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCEYgFPf+RXFR9WExDBEeFSbOXnOg9R6zUvz/dDP0dY0emP/xrFS+t5bs0XGi1joRZ30sMbPWWyfAbKPziWaZ+VYuNOsDEyFF2CFZskZi3r3lYicnTns0zGhdtrXb3X+uDNavR1Fik8VnwByo8oWmW+4y5jU5k8AbAWmPlPzCPS4QIDAQAB';
      encrypt.setPublicKey(publicKey);
      // 要加密的数据
      var plaintext = this.ruleForm.password;
      // 进行 RSA 加密
      var encrypted = encrypt.encrypt(plaintext);

      post("login", {
        email: this.ruleForm.username,
        password: encrypted,
      }).then((res) => {
        console.log("登录结果", res);
        if (res.code == 0) {
          localStorage.setItem('userId', res.data.userId);
          if (!res.data.ltime || res.data.ltime == undefined) { //首次登录，去重置密码
            this.$router.push('/resetInitialPassword');
          } else {
            localStorage.setItem("accessToken", res.data.accessToken); //缓存拿到的token值
            localStorage.setItem("refreshToken", res.data.refreshToken);
            localStorage.setItem("email", res.data.email);
            this.$router.replace('/mainView');
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handlePasswordVisibility() {
      this.showPassword = !this.showPassword;
      this.eyeIcon = this.showPassword ? require('../assets/images/icon-unsecured.png') : require('../assets/images/icon-secure.png');
    },
    handleCreateAccount() {
      console.log('注册新号');
      this.$router.push('/register');
    },
    handleRestPassword() {
      this.$router.push('/resetPassword');
    },
  },
};
</script>

<style scoped>
#loginPage {
  background: url("../assets/images/login-bg.jpg") no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-style: normal;
  font-weight: 400;
  height: 100vh;
}

.login-logo {
  background: url("../assets/images/logo.png") no-repeat;
  width: 309px;
  height: 46px;
}

.login-container {
  border-radius: 15px;
  margin: 40px auto;
  width: 580px;
  padding: 30px 65px 15px 65px;
  background: #fff;
  border: 1px solid #eaeaea;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
}

.title {
  margin: 0px auto auto auto;
  color: black;
  font-weight: 700;
  font-style: normal;
  font-size: 22px;
}

.subtitle {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}

.newAccount {
  display: flex;
  align-items: center;
  color: #88C22E;
  border-bottom: none;
  text-decoration: none;
}

.password-reset {
  display: flex;
  align-items: center;
  color: #88C22E;
  cursor: pointer;
}

.user-icon {
  margin-left: 20px;
  margin-top: 16px;
  height: 16px;
  width: 16px;
}

.lock-icon {
  margin-left: 20px;
  margin-top: 13px;
  height: 22px;
  width: 22px;
}

.secrecy-icon {
  margin-right: 20px;
  margin-top: 13px;
  height: 22px;
  width: 22px;
}

.login-input>>>.el-input__inner {
  height: 50px;
  border: 1px solid lightgray;
  width: 100%;
  border-radius: 6px;
  padding-left: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
}

.login-button {
  width: 100%;
  height: 50px;
  margin-top: 20px;
  margin-bottom: 40px;
  background-color: rgb(148, 200, 66);
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 700;
  font-style: normal;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue